import React from "react";
import { Spin, Select } from "antd";

import { compose, config, resetFilterHook } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withSets } from "src/modules/set/operations";

import { withStateAndActionsForSet } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const {
        loading,
        sets,
        where,
        onNameChange,
        onChange,
        value,
        onStateReset,
        dropdownOpen,
    } = props;
    resetFilterHook(onStateReset);
    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"sets"}
            component={RenderSelect}
            placeholder={"Sets"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
            mode={"multiple"}
            open={dropdownOpen}
        >
            {[
                // config.EMPTY_OPTION,
                ...(sets?.map((set) => ({
                    id: set.id,
                    label: set.title || "",
                    value: set.id,
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForSet, withSets)(SubjectsField);
